import createModule from "../createModule"
import view from "./view"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getResourceType, getTabs, getResourceId, getResourceTeams, getAccountTeams, getPermissionLevel } from "./selectors"
import withUrlParams from "hocs/withUrlParams"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    userId: props.params.userId,
    resourceAlias: props.params.resourceAlias,
    resourceType: getResourceType(state, props),
  }),
  required: ["account", "resourceAlias", "resourceType"],
  data: [{
    resource: "resourceTeams",
    passthrough: true,
    url: ({ resourceAlias, resourceType }) => {
      return {
        id: `resource-teams-${resourceAlias}`,
        query: `query($resourceAlias:IdOrShortIdOrAlias!, $resourceType:ResourceType!){
          resource(id:$resourceAlias, type:$resourceType){
            id
            name
            alias
            type
            permissionLevel
            teams {
              id
              description
              alias
              name
              permissionLevel
              createdAt
            }
          }
        }`,
        variables: {
          resourceAlias,
          resourceType,
        },
      }
    },
  },
  {
    resource: "accountTeams",
    passthrough: true,
    url: ({ account }) => {
      return {
        id: `account-teams-${account}`,
        query: `query{
            teams{
              id
              name
              createdAt
            }
        }`,
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    resourceId: getResourceId(state, props),
    resourceTeams: getResourceTeams(state, props),
    accountTeams: getAccountTeams(state, props),
    permissionLevel: getPermissionLevel(state, props),
    role: getRole(state),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
